/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!***************************************!*\
  !*** ./scripts/facet-size-toggler.js ***!
  \***************************************/
if (document.body.contains(document.querySelector(".facets-layout-list-size"))) {
  document.addEventListener("click", function (e) {
    var targetClick = e.target.closest(".toggler-button");
    var listSize = document.querySelector(".facets-layout-list-size");
    var buttonSize = listSize.querySelectorAll("button");
    buttonSize.forEach(function (button) {
      if (targetClick == button) {
        var listTarget = targetClick.getAttribute("data-target");
        var showList = listSize.querySelectorAll("li.".concat(listTarget));
        button.classList.toggle("shown");
        showList.forEach(function (item) {
          return item.classList.toggle("hidden");
        });
      }
    });
  });
}
if (document.body.contains(document.querySelector(".mobile-facets-layout-list-size"))) {
  document.addEventListener("click", function (e) {
    var targetClick = e.target.closest(".mobile-toggler-button");
    var listSize = document.querySelector(".mobile-facets-layout-list-size");
    var buttonSize = listSize.querySelectorAll(".mobile-toggler-button");
    buttonSize.forEach(function (button) {
      if (targetClick == button) {
        var listTarget = targetClick.getAttribute("data-target");
        var showList = listSize.querySelectorAll("li.".concat(listTarget));
        button.classList.toggle("shown");
        showList.forEach(function (item) {
          return item.classList.toggle("hidden");
        });
      }
    });
  });
}
/******/ })()
;